import type { ReactNode } from 'react'
import { cn } from '../lib/utils'
import { Badge } from './badge'

const dot = {
  positive: 'bg-positive',
  warning: 'bg-warning',
  neutral: 'bg-foreground',
  faint: 'bg-muted-foreground',
  destructive: 'bg-destructive',
} as const

export type Tone = keyof typeof dot

export function StatusDot({ tone }: { tone: Tone }) {
  return <span className={cn('size-1.5 shrink-0 rounded-full', dot[tone])} />
}

export function StatusBadge({
  tone,
  children,
}: {
  tone: Tone
  children: ReactNode
}) {
  return (
    <Badge variant="secondary" className="gap-1.5 font-normal">
      <StatusDot tone={tone} />
      {typeof children === 'string'
        ? children.charAt(0).toUpperCase() + children.slice(1)
        : children}
    </Badge>
  )
}
